import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { firstAllowedRoute } from "../lib/permissions";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={firstAllowedRoute(user)} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) setError(res.error);
    else navigate(firstAllowedRoute(res.user), { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#0A0B10] relative overflow-hidden flex items-center justify-center p-6">
      <div className="absolute inset-0 grid-grain opacity-40 pointer-events-none" />
      <div className="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-transparent via-[#00D4FF] to-transparent" />

      <div className="relative z-10 w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="font-heading font-bold text-lg tracking-tight">
            UDI<span className="text-[#00D4FF]">/OPS</span>
          </div>
          <div className="text-[10px] tracking-[0.25em] uppercase text-muted-foreground mt-1">
            Unlimited Designs Production Dashboard
          </div>
        </div>

        <div className="text-[10px] tracking-[0.35em] uppercase text-[#00D4FF] mb-3">Authenticate</div>
        <h2 className="font-heading font-bold text-3xl mb-8">Sign in to continue.</h2>

        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
          <div>
            <label className="text-[10px] tracking-[0.25em] uppercase text-muted-foreground mb-2 block">Email</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Email"
              className="w-full bg-[#12141D] border border-border px-3 py-2.5 text-sm focus:outline-none focus:border-[#00D4FF] transition-colors"
            />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.25em] uppercase text-muted-foreground mb-2 block">Password</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Password"
              className="w-full bg-[#12141D] border border-border px-3 py-2.5 text-sm focus:outline-none focus:border-[#00D4FF] transition-colors"
            />
          </div>

          {error && (
            <div data-testid="login-error" className="text-xs text-red-400 border border-red-500/30 bg-red-500/5 px-3 py-2">
              {error}
            </div>
          )}

          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#00D4FF] text-[#0A0B10] font-semibold text-sm tracking-widest uppercase py-3 hover:bg-[#00B8D4] transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In →"}
          </button>
        </form>
      </div>
    </div>
  );
}
